import type { CountryType } from "../../../../@types/generic";

const config: Record<
    CountryType,
    Array<{ name: string; code: string; seoString: string }>
> = {
    pl: [
        {
            name: "Warszawa",
            code: "PL0MZ0005",
            seoString: "polska/warszawa",
        },
        {
            name: "Gdańsk",
            code: "PL0PM0002",
            seoString: "polska/gdansk",
        },
        {
            name: "Kraków",
            code: "PL0MA0001",
            seoString: "polska/krakow",
        },
        {
            name: "Wrocław",
            code: "PL0DS0004",
            seoString: "polska/wroclaw",
        },
        {
            name: "Poznań",
            code: "PL0WP0003",
            seoString: "polska/poznan",
        },
        {
            name: "Szczecin",
            code: "PL0ZP0002",
            seoString: "polska/szczecin",
        },
        {
            name: "Lublin",
            code: "PL0LU0001",
            seoString: "polska/lublin",
        },
        {
            name: "Bydgoszcz",
            code: "PL0KP0001",
            seoString: "polska/bydgoszcz",
        },
        {
            name: "Łódź",
            code: "PL3093133",
            seoString: "polska/lodz",
        },
        {
            name: "Katowice",
            code: "PL0SL0004",
            seoString: "polska/katowice",
        },
        {
            name: "Toruń",
            code: "PL3083271",
            seoString: "polska/torun",
        },
        {
            name: "Białystok",
            code: "PL0776069",
            seoString: "polska/bialystok",
        },
        {
            name: "Gdynia",
            code: "PL0PM0003",
            seoString: "polska/gdynia",
        },
        {
            name: "Rzeszów",
            code: "PL0PK0001",
            seoString: "polska/rzeszow",
        },
        {
            name: "Olsztyn",
            code: "PL0WN0003",
            seoString: "polska/olsztyn",
        },
        {
            name: "Częstochowa",
            code: "PL0SL0002",
            seoString: "polska/czestochowa",
        },
        {
            name: "Jelenia Góra",
            code: "PL0DS0003",
            seoString: "polska/jelenia-gora",
        },
        {
            name: "Zamość",
            code: "PL0753866",
            seoString: "polska/zamosc",
        },
    ],
    de: [],
    at: [],
    ch: [],
    cs: [],
    da: [],
    es: [],
    fr: [],
    it: [],
    nl: [],
    ro: [],
    sk: [],
    sv: [],
    us: [],
    uk: [],
};

export default config;
